// Module
var code = "<section class=\"error-text {{ ::$ctrl.customClass }}\" ng-show=\"$ctrl.form.$submitted && $ctrl.form.$invalid\"> <span class=\"icon-cr-error\"></span> <span>{{ ::$ctrl.errorText }}</span> </section> ";
// Exports
export default code;